import React from 'react';
import { Carousel } from 'antd';

import launchSystem from '../../../../Assets/Linkages/StudentSatelliteOutreach/Events/STEM-Based-Training/cansat-launch-system.jpg';
import groundStation from '../../../../Assets/Linkages/StudentSatelliteOutreach/Events/STEM-Based-Training/cansat-ground-station.png';
import hardwareTraining from '../../../../Assets/Linkages/StudentSatelliteOutreach/Events/STEM-Based-Training/satellite-hardware-training.jpg';

const trainingImages = [
  { src: launchSystem, alt: 'CanSat launch system undergoing flight testing' },
  { src: groundStation, alt: 'CanSat ground-station interface displaying live telemetry' },
  { src: hardwareTraining, alt: 'Satellite systems hardware training session' },
];

const StudentSatelliteTraining = () => (
  <section className="student-satellite-training" aria-labelledby="student-satellite-training-title">
    <div className="student-satellite-training-inner">
      <div className="student-satellite-training-copy">
        <p className="section-eyebrow">FROM MISSION DESIGN TO LAUNCH</p>
        <h2 id="student-satellite-training-title">STEM-Based Training in Satellite Systems Engineering</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          Our satellite outreach programs immerse students in the complete journey of satellite
          development, from mission planning to launch. Participants engage in mission design,
          subsystem development—including power, communication, payload, and structure—and system
          integration using microcontrollers and sensors. The process advances to system assembly,
          testing, real-time data collection, and launch, offering practical exposure to real-world
          space engineering workflows. These programs equip students with technical skills in embedded
          systems, teamwork, and systems engineering, preparing them for future roles in the space industry.
        </p>
      </div>

      <Carousel
        className="student-satellite-training-carousel"
        autoplay
        autoplaySpeed={3600}
        pauseOnHover
        dots
        effect="fade"
      >
        {trainingImages.map((image) => (
          <figure key={image.src}>
            <img src={image.src} alt={image.alt} loading="lazy" />
          </figure>
        ))}
      </Carousel>
    </div>
  </section>
);

export default StudentSatelliteTraining;
